import { Injectable } from '@angular/core';
import { Task } from '../dto/task';

/*
  Generated class for the TaskLogicProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class TaskLogicProvider {

  constructor() {
    console.log('Hello TransportLogicProvider Provider');
  }

  /**
   * Selects next page in task process depending on task type and state
   * @param pTaskList 
   */
  public getNextPageDependingOnActiveTasks(pTaskList : Task[]) : string {
    if(pTaskList.length > 0) {
      //get first task and check type:
      if(pTaskList[0].type === "TI") {
        // Ok, have an inbound transport task lets only take those and check what to do next:
        let taskList : Task[] = [];
        for(var t of pTaskList) {
          if(t.type === "TI") {
            taskList.push(t);
          }
        }

        // now that we are sure, we only have TI types, sort tasks by state:
        taskList.sort((a, b) => {if(a.state < b.state) return -1; if(a.state>b.state) return 1; return 0;});
        
        // if smallest state is 16 we will have to pick up a barcode:
        if(taskList[0].state === 16)
          return "TaskTransportSourcePage";
        // smallest state is 20 then we will go to target scann page
        if(taskList[0].state === 20)
          return "TaskTransportTargetPage";
        return "TaskSearchPage";
      }
    }
    return "TaskSearchPage";
  }
}



// WEBPACK FOOTER //
// ./src/providers/task-logic/task-logic.ts